import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { UserProfileInfo } from '@app/core/_models'
import { UserDateFormattingService } from '@app/core/_services/user-date-formatting.service'
import {
    SaveUserRequest,
    UserRelationshipService,
} from '@app/core/_services/user-relationship.service'
import { DisplayTimezoneLocalTimeComponent } from '@app/shared/components/display-timezone-local-time/display-timezone-local-time.component'
import { FmAvatarComponent } from '@app/shared/components/fm-avatar/fm-avatar.component'
import {
    ALL_ACTIVITY_TAGS,
    ALL_DESCRIPTION_TAGS,
} from '@app/shared/components/profile-tag-selector/profile-tag-selector.component'
import { ActionsMenuComponent } from '@app/user-actions/components/actions-menu/actions-menu.component'
import { ButtonModule } from 'primeng/button'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { TagModule } from 'primeng/tag'
import { Subject } from 'rxjs'

@Component({
    selector: 'fm-user-profile',
    imports: [
        CommonModule,
        DisplayTimezoneLocalTimeComponent,
        FmAvatarComponent,
        ActionsMenuComponent,
        ButtonModule,
        ScrollPanelModule,
        TagModule,
    ],
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileComponent {
    @Input() userProfile: UserProfileInfo

    public memberSinceString: string = ''
    public snoozeTooltip: string = ''
    public lastMet: string = ''

    public descriptionTagDisplayNames: string[] = []
    public activityTagDisplayNames: string[] = []
    private ngUnsubscribe: Subject<any> = new Subject<any>()

    constructor(
        private dateFormat: UserDateFormattingService,
        private userRelationshipService: UserRelationshipService,
    ) {}

    ngOnInit() {
        this.updateProfileInfo()
    }

    ngOnChanges() {
        this.updateProfileInfo()
    }

    private updateProfileInfo() {
        if (this.userProfile) {
            this.lastMet = this.dateFormat.generateLastMetString(this.userProfile.lastSessionTime)
            this.descriptionTagDisplayNames = this.userProfile.profileTags?.descriptionTags?.map(
                (tag) => ALL_DESCRIPTION_TAGS.find((t) => t.value === tag).displayName,
            )
            this.descriptionTagDisplayNames = this.descriptionTagDisplayNames || []
            this.activityTagDisplayNames = this.userProfile.profileTags?.activityTags?.map(
                (tag) => ALL_ACTIVITY_TAGS.find((t) => t.value === tag).displayName,
            )
            this.activityTagDisplayNames = this.activityTagDisplayNames || []
        }
    }

    onClickAddToFavofites(): void {
        const saveUserRequest: SaveUserRequest = {
            userId: this.userProfile.uid,
            saveUser: true,
        }

        // NOTE: UserRelationShipService will trigger an update
        // and emit an event to indicate the completed action.
        // ProfileContainer will listen and update all child components
        this.userRelationshipService.saveUser(saveUserRequest).subscribe()
    }
}
